import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthState } from 'app/core/state/auth.state';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router = inject(Router);
    const authState = inject(AuthState);

    // console.log('=== AuthGuard ===');
    // console.log('Route:', state.url);
    // console.log('isInitialized:', authState.isInitialized());
    // console.log('isAuthenticated:', authState.isAuthenticated());

    if (!authState.isInitialized()) {
        console.log('AuthGuard: NOT INITIALIZED - blocking');
        const redirectURL = state.url === '/sign-out' ? '' : state.url;
        if (redirectURL) {
            sessionStorage.setItem('redirectUrl', redirectURL);
        }
        router.navigate(['/sign-in']);
        return false;
    }

    if (!authState.isAuthenticated()) {
        console.log('AuthGuard: NOT AUTHENTICATED - blocking');
        const redirectURL = state.url === '/sign-out' ? '' : state.url;
        if (redirectURL) {
            sessionStorage.setItem('redirectUrl', redirectURL);
        }
        router.navigate(['/sign-in']);
        return false;
    }

    // console.log('AuthGuard: ALLOWED');
    return true;
};